import { ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { showAlert: boolean }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    alert: {
      display: ({ showAlert }) => (showAlert ? 'flex' : 'none'),
      width: 662,
      marginBottom: -73,
      marginTop: 24,
      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: -85,
        width: '100%',
      },
    },
    buttonToggle: {
      margin: 'auto',
      marginTop: 20,
      width: 400,
      backgroundColor: '#FFFFFF',
      [mediaQuery(breakpoints.tablet)]: {
        marginTop: 16,
        width: 346,
      },
    },
    imageContainer: {
      margin: 'auto',
      marginBottom: 20,
      [mediaQuery(breakpoints.tablet)]: {
        width: 112,
        height: 98,
        marginBottom: 24,
      },
    },
    button: {
      marginTop: 16,
      padding: 16,
      [mediaQuery(breakpoints.tablet)]: {
        padding: [12, 75],
      },
    },
    heroBanner: {
      '& > article': {
        paddingTop: 42,
        [mediaQuery(breakpoints.tablet)]: {
          paddingTop: 24,
          '& h1': {
            marginBottom: 16,
          },
        },
        '& > div > p': {
          maxWidth: 895,
          marginBottom: 24,
          [mediaQuery(breakpoints.tablet)]: {},
        },
      },
    },
    demoArea: {
      marginTop: 24,
    },
    footer: {
      marginTop: 'auto',
    },
    stepsSection: {
      marginBottom: '84px',
      marginTop: '70px',
      '& h2': { maxWidth: 900 },
      '& > div > div': {
        marginBottom: 24,
      },
      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: '38px',
        marginTop: '40px',
        '& > div > div': {
          marginBottom: 16,
        },
      },
    },
    faqSections: {
      marginTop: '103px',
      marginBottom: '64px',
      [mediaQuery(breakpoints.tablet)]: {
        marginTop: '40px',
        marginBottom: '24px',
      },
    },
    boldText: {
      fontWeight: 'bold',
      color: '#C209C1',
    },
    imageWithTextSection: {
      margin: [40, 'auto'],
      padding: [40, 0],

      '& > div': {
        margin: 'auto',
        gap: 130,
      },
      [mediaQuery(breakpoints.tablet)]: {
        margin: [20, 'auto'],
        padding: [20, 24],
        '& > div': {
          gap: 42,
        },
      },
    },
    textContainerClassName: {
      maxWidth: 557,
      [mediaQuery(breakpoints.tablet)]: {
        margin: 'auto',
      },
    },
  }),
  {
    name: 'home',
  },
);

export default useStyles;
